import GlobalDialog from "../../../../../components/mui/Dialogue/GlobalDialog";
import React, { useEffect, useState } from "react";
import {
  Box,
  Checkbox,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import ExcludeUser from "./ExcludeUser";
import ChangeReviewer from "./ChangeReviewer";
import IncludeUser from "./IncludeUser";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllEvaluationcycle,
  getCycleAssignedUsers,
} from "../../../../../redux/features/appraisalSlice";
import GlobalWrapper from "../../../../../components/Wrapper/GlobalWrapper";
import Loader3D from "../../../../../components/Loader/Loader3D";
import NoDataFound from "../../../../../components/NodataIndication/NoDataFound";

const ManageUser = ({ open, setOpen, id, status }) => {
  const dispatch = useDispatch();
  const [selectedUserIds, setSelectedUserIds] = useState([]);
  const [updateValidation, setUpdateValidation] = useState(false);
  const { cycleAssignedUsers, loading } = useSelector(
    (state) => state.appraisal
  );

  useEffect(() => {
    if (open) {
      dispatch(getCycleAssignedUsers(id));
    }
    if (!open && updateValidation) {
      dispatch(getAllEvaluationcycle());
    }
  }, [open]);

  const handleCheckboxChange = (userId) => {
    setSelectedUserIds((prevSelected) =>
      prevSelected.includes(userId)
        ? prevSelected.filter((id) => id !== userId)
        : [...prevSelected, userId]
    );
  };
  return (
    <GlobalDialog
      open={open}
      setOpen={setOpen}
      title={"Manage User"}
      fullScreen
      closeButton={true}
      content={
        <>
          {open ? (
            <GlobalWrapper>
              {/* {loading ? (
                <Loader3D />
              ) : ( */}
              <Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    flexDirection: "row",
                    gap: 2,
                  }}
                >
                  {selectedUserIds.length > 1 ? (
                    <ExcludeUser
                      ids={selectedUserIds}
                      setSelectedUserIds={setSelectedUserIds}
                      cycleId={id}
                      setUpdateValidation={setUpdateValidation}
                    />
                  ) : null}
                  {status === 2 ? null : (
                    <IncludeUser
                      cycleId={id}
                      setUpdateValidation={setUpdateValidation}
                    />
                  )}
                </Box>
                <Box p={2}>
                  {cycleAssignedUsers.length === 0 ? (
                    <NoDataFound />
                  ) : (
                    <TableContainer component={Paper}>
                      <Table>
                        <TableHead sx={{ backgroundColor: "#f5f5f5" }}>
                          <TableRow>
                            <TableCell>check</TableCell>
                            <TableCell>User ID</TableCell>
                            <TableCell>Username</TableCell>
                            <TableCell>User Role</TableCell>
                            <TableCell>Reviewer</TableCell>
                            <TableCell>Manager Review Status</TableCell>
                            <TableCell>Change Reviewer</TableCell>
                            <TableCell>Exclude User</TableCell>
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {cycleAssignedUsers.map((user) => (
                            <TableRow key={user.userId}>
                              <TableCell>
                                <Checkbox
                                  disabled={status === 2 ? true : false}
                                  checked={selectedUserIds.includes(
                                    user.appraisal_cycle_assignment_id
                                  )}
                                  onChange={() =>
                                    handleCheckboxChange(
                                      user.appraisal_cycle_assignment_id
                                    )
                                  }
                                />
                              </TableCell>
                              <TableCell>{user.userID}</TableCell>
                              <TableCell>{user.assigned_user}</TableCell>
                              <TableCell>{user.designationName}</TableCell>
                              <TableCell>{user.manager_name}</TableCell>
                              <TableCell>
                                {user.review_status === 0
                                  ? "Pending"
                                  : "Completed"}
                              </TableCell>
                              <TableCell>
                                {status === 2 ? null : (
                                  <ChangeReviewer
                                    cycleId={id}
                                    userId={user.userID}
                                  />
                                )}
                              </TableCell>
                              <TableCell>
                                {status === 2 ? null : (
                                  <ExcludeUser
                                    ids={[user.appraisal_cycle_assignment_id]}
                                    setSelectedUserIds={setSelectedUserIds}
                                    cycleId={id}
                                  />
                                )}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  )}
                </Box>
              </Box>
              {/* )} */}
            </GlobalWrapper>
          ) : null}
        </>
      }
    />
  );
};

export default ManageUser;
